module.exports = __webpack_public_path__ + "img/b62.fe721ab4.jpg";